/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The available sort by criteria to choose from.
 */
export type ConnectedAudiologistSortByParam =
  (typeof ConnectedAudiologistSortByParam)[keyof typeof ConnectedAudiologistSortByParam];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConnectedAudiologistSortByParam = {
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
  CHAIN_NUMBER_ASC: "CHAIN_NUMBER_ASC",
  CHAIN_NUMBER_DESC: "CHAIN_NUMBER_DESC",
} as const;
